import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import { unpack, type, reverse3 } from '../../utils/index.js';
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import lch2rgb from './lch2rgb.js';
import hcl2rgb from './hcl2rgb.js';
import rgb2lch from './rgb2lch.js';
Color.prototype.lch = function () {
  return rgb2lch(this._rgb);
};
Color.prototype.hcl = function () {
  return reverse3(rgb2lch(this._rgb));
};
var lch = function lch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['lch']));
};
var hcl = function hcl() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return _construct(Color, args.concat(['hcl']));
};
Object.assign(chroma, {
  lch: lch,
  hcl: hcl
});
input.format.lch = lch2rgb;
input.format.hcl = hcl2rgb;
['lch', 'hcl'].forEach(function (m) {
  return input.autodetect.push({
    p: 2,
    test: function test() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      args = unpack(args, m);
      if (type(args) === 'array' && args.length === 3) {
        return m;
      }
    }
  });
});
export { lch, hcl };